export default [
  {
    path: '/real-estate-developments-settings/proposal-model',
    name: 'ProposalModelsList',
    component: () => import('pages/real-estate-developments-settings/proposal-model/ProposalModelsList.vue')
  },
  {
    path: '/real-estate-developments-settings/proposal-model/new',
    name: 'ProposalModelsCreate',
    component: () => import('pages/real-estate-developments-settings/proposal-model/ProposalModelsForm.vue')
  },
  {
    path: '/real-estate-developments-settings/proposal-model/:id/edit',
    name: 'ProposalModelsEdit',
    component: () => import('pages/real-estate-developments-settings/proposal-model/ProposalModelsForm.vue')
  },
  {
    path: '/real-estate-developments-settings/proposal-model/:id',
    name: 'ProposalModelsSingle',
    component: () => import('pages/real-estate-developments-settings/proposal-model/ProposalModelsSingle.vue')
  }
]
